import type { KeyValue } from "@/main/models/common";

const SCROLL_BOTTOM_THRESHOLD = 5;

export function isKeyValue(value: unknown): value is KeyValue {
	return typeof value === "object" && value !== null && "key" in value && "value" in value;
}

export function isSameOption(option: KeyValue, selected: KeyValue): boolean {
	return String(option.key) === String(selected.key);
}

export function includeSelectedOption(options: KeyValue[], selected: KeyValue | null): KeyValue[] {
	if (!selected || options.some((option) => isSameOption(option, selected))) {
		return options;
	}
	return [selected, ...options];
}

export function isScrolledToBottom({ scrollHeight, scrollTop, clientHeight }: HTMLElement): boolean {
	return scrollHeight - (scrollTop + clientHeight) <= SCROLL_BOTTOM_THRESHOLD;
}
